angular.module('bmsApp')
	.factory('CRUDSvc', [
		'$http',
		'$log',
		'$window',
		'$q',
		function ($http,
				  $log,
				  $window,
				  $q) {

			return {
				get: function (url, params) {
					// does not accept unformatted momentjs objects
					// could potentially add an alternative get method or an option to not use $.param
					var query = $.param(angular.extend({}, params));

					var deferred = $q.defer();
					$http.get(url + '?' + query)
						.then(function (response) {
							if (response.data.success) {
								deferred.resolve(response);
							}
							else {
								deferred.reject(response.data.errors);
							}
						}, function (error) {
							deferred.reject("A generic API error occured: " + error.data.error.message);
						});

					return deferred.promise;
				},
				post: function (url, data) {
					var deferred = $q.defer();
					$http({
						url: url,
						method: 'POST',
						data: data,
						headers: {
							'Accept': 'application/json',
						}
					})
						.then(function (response) {
							if (response.data.success) {
								deferred.resolve(response);
							}
							else {
								deferred.reject(response.data.errors);
							}
						}, function (error) {
							deferred.reject('A generic API error occured: ' + error.data.error.message);
						});

					return deferred.promise;
				},
				index: function (api, params) {
					console.warning('USING DEPRECATED CRUDSvc.index()');
				},
				create: function (url, data) {
					return this.post(url, data);
				},
				read: function (url, id) {
					return this.get(url + '/' + id);
				},
				update: function (url, id, data) {
					return this.post(url + '/' + id, data);
				},
				delete: function (url, id) {
					return this.get(url + '/' + id);
				},
				open: function (url, params) {
					var query = $.param(angular.extend({}, params));
					$window.open(url + '?' + query);
				},
				checkPin: function (params){
					return this.post('api/resource/directory/validate-pin',  params);
				}
			};

		}
	]);
